import { useEffect, useState } from 'react'
import { subscribeToFeedback, subscribeToNewFeedbackCount } from '@/features/feedback/feedback-api'
import type { FeedbackMessage, FeedbackType } from '@/lib/types'

type FeedbackState = {
  items: FeedbackMessage[]
  isLoading: boolean
  error: string | null
}

/** Live messages of one kind; re-subscribes when the selected type changes. */
export function useFeedback(type: FeedbackType): FeedbackState {
  const [state, setState] = useState<FeedbackState>({ items: [], isLoading: true, error: null })

  useEffect(() => {
    setState({ items: [], isLoading: true, error: null })
    return subscribeToFeedback(
      type,
      (items) => setState({ items, isLoading: false, error: null }),
      (error) =>
        setState({
          items: [],
          isLoading: false,
          error: error.message.includes('permission')
            ? 'Firestore отклонил чтение коллекции feedback. Проверьте, что правила с блоком feedback опубликованы и у вас роль admin.'
            : error.message,
        }),
    )
  }, [type])

  return state
}

/** Count of unreviewed messages of both kinds, for the sidebar badge. */
export function useNewFeedbackCount(): number {
  const [count, setCount] = useState(0)
  useEffect(() => subscribeToNewFeedbackCount(setCount), [])
  return count
}
